import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import moment from "moment";
import { checkPermission } from "../../screen/redux/api/PermissionManager";

const Accepted = ({ ownersList, pagination, page, setPage }) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);/
  // const [pagination, setPagination] = useState("");
  const [popup, setPopup] = useState(false);

  const [owners, setOwners] = useState(ownersList);

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];
  const ownerList = [
    { id: 1, name: "John Doe", age: 28, city: "New York" },
    { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
    { id: 3, name: "Sam Brown", age: 22, city: "Chicago" },
    { id: 4, name: "Emily Johnson", age: 25, city: "Miami" },
    { id: 5, name: "Michael Davis", age: 40, city: "San Francisco" },
  ];
  useEffect(() => {
    setOwners(ownersList);
  }, [ownersList]);

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Ticket ID",
        accessor: "ticket_id",
        accessorFn: (row) => row.ticket_transaction?.ticket,

        Cell: ({ value, row }) => {
          return (
            <p className="primary pointer">
              {row?.original?.ticket_transaction?.ticket || "-"}
            </p>
          );
        },
      },
      {
        Header: "User",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return <p className="primary pointer">{value}</p>;
        },
      },
      {
        Header: " Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Wallet Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Generated Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">{moment(value).format("DD/MM/YYYY")}</p>
          );
        },
      },
      {
        Header: "Requested by",
        accessor: "requested_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Current status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">
              {value === 1 || value === 2
                ? "Accepted"
                : value === 3
                ? "Used"
                : value === 4
                ? "Expired"
                : ""}
            </p>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        console.log("DSASLDSAa", row?.original?.id);

        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/wallettransactionadd", {
                    state: { type: "view", userDatas: row?.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>

              {/* <button
                onClick={() => {
                  navigate("/wallettransactionadd", {
                    state: { type: "edit", userDatas: row?.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={edit_icon} alt="" className=" edit-btn " />
              </button> */}

              {/* <button onClick={() => setPopup(true)} className="cust-btn ">
                <img src={delete_icon} alt="" className=" edit-btn " />
              </button> */}
              {/* <input
                type="checkbox"
                checked={row.original.selected}
                onChange={() => handleCheckboxToggle(row?.original?.id)}
              /> */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-WALLETUSER") ? [...d, action] : d;
  }, [page]);
  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Accepted;
